import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/swiper-bundle.css";
import yogaGirl from "../../assets/images/sahaj-dhyan/svg/yog-girl.svg";
import buttonYellowLeftImg from "../../assets/images/svg/button-yellow-left-layer.svg";
import buttonYellowRightImg from "../../assets/images/svg/button-yellow-right-layer.svg";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import CommonHeading from "../common/heading/CommonHeading";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { SwiperLeftIcon, SwiperRightIcon } from "../common/icons/Icons";
import { Link } from "react-router-dom";
import Button from "../common/button/Button";

const SadhakExperience = () => {
  const [swiper, setSwiper] = useState(null);
  const handleMoveNextSlide = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };
  const handlePrevSlide = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };
  return (
    <>
      <div className="pt-3 py-lg-5 mb-lg-5 position-relative">
        {/*<img
          className="position-absolute top_flower_mahamantra top_flower_experiences d-none d-md-block"
          src={topFlowerImg}
          alt="top_flower"
        />*/}
        <div className="container container_modified pb-sm-5 pb-lg-0">
          <div className="px-lg-5 mx-lg-5">
            <CommonHeading
              heading="Sadhaka's"
              className="text-orange common_heading_text common_heading_text_brown"
            />
            <h4 className="common_sub_heading text-center pt-1 pb-3 mb-0">
              Experiences of <br />
              Sahaj Dhyan
            </h4>
          </div>
          <Swiper
            onSwiper={setSwiper}
            spaceBetween={50}
            slidesPerView={1}
            loop={true}
            style={{ borderRadius: "17px" }}
          >
            <SwiperSlide>
              <div className="sadhak_experience_bg py-5 px-3 px-sm-5 mt-lg-5 d-lg-flex mx-2">
                <div className="pt-4 pt-sm-5 pt-lg-0 ps-lg-5 text-center text-lg-start sadhak_experience_text_parent pb-sm-4 mb-3">
                  <h6 className="font-lg fw-semibold text-white mb-0 pt-2">
                    D.B. Crestone, USA
                  </h6>
                  <p className="font-sm fw-medium text-white mt-3 mb-0 lh_25">
                    "I sat down, not wishing for anything, so I asked God to bless me in any way he felt I needed. I had lost my son at age 22 a few years before. When the chanting of the Mahamantra stopped, I had the vision of my son at every year. He was coming to me and smiling and hugging me with each vision. This experience was very powerful and brought such enormous release that it will be with me forever.."
                  </p>
                  <div className="pt-3 pt-lg-0 mt-lg-5 position-relative w_fit_content mx-auto mx-lg-0">
                    <Link to="/hari-om-tatsat-jai-guru-datta">
                      <Button title="Learn More" />
                    </Link>
                  </div>
                </div>
                <div className="pt-4 pt-sm-5 w-lg-25 sadhak_experience_img_parent">
                  <img
                    className="pt-lg-5 ps-lg-3 pb-3 pb-lg-0 mt-lg-5"
                    src={yogaGirl}
                    alt="yog-girl"
                  />
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="sadhak_experience_bg py-5 px-3 px-sm-5 mt-lg-5 d-lg-flex mx-2">
                <div className="pt-4 pt-sm-5 pt-lg-0 ps-lg-5 text-center text-lg-start sadhak_experience_text_parent pb-sm-4 mb-3">
                  <h6 className="font-lg fw-semibold text-white mb-0 pt-2">
                      K.L.  St. George, USA
                  </h6>
                  <p className="font-sm fw-medium text-white mt-3 mb-0 lh_25">
                    "There was, on my first experience of the mantra, an experience of peace. Then came sadness, deep sadness. I would dip back into the peace, and then this deep sadness would return. And this back and forth between peace and sadness continued for most of the meditation.
                  </p>
                  <div className="pt-3 pt-lg-0 mt-lg-5 position-relative w_fit_content mx-auto mx-lg-0">
                    <Link to="/hari-om-tatsat-jai-guru-datta">
                      <Button title="Learn More" />
                    </Link>
                  </div>
                </div>
                <div className="pt-4 pt-sm-5 w-lg-25 sadhak_experience_img_parent">
                  <img
                    className="pt-lg-5 ps-lg-3 pb-3 pb-lg-0 mt-lg-5"
                    src={yogaGirl}
                    alt="yog-girl"
                  />
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="position-relative d-flex  justify-content-center mt-4 mt-lg-0 pt-lg-0 pt-1 gap-3">
            <span
              className="swiper_buttons swiper_left_button"
              onClick={handlePrevSlide}
            >
              <SwiperLeftIcon />
            </span>
            {/* Next slide button */}
            <span
              className="swiper_buttons swiper_right_button"
              onClick={handleMoveNextSlide}
            >
              <SwiperRightIcon />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default SadhakExperience;
